import { createSlice } from '@reduxjs/toolkit';

import { AccessRequestInfo, AccessRequestState } from './types/accessRequest';

const initialState: AccessRequestState = {
  accessRequest: null,
};

export const UserAccessData = createSlice({
  name: 'UserAccess',
  initialState,
  reducers: {
    setAccessRequestInfo: (
      state: AccessRequestState,
      { payload }: { payload: AccessRequestInfo | null },
    ) => {
      return { ...state, accessRequest: payload };
    },
    resetAccessRequestInfo: () => initialState,
  },
});

export const { setAccessRequestInfo, resetAccessRequestInfo } = UserAccessData.actions;

export default UserAccessData.reducer;
